import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { getSpeakerBasicHeaders } from '../../common/utils/utils';
import { speakerSearchConstants } from '../../components/Speakers/speakerConstant';
import { getAxiosCancelTokenSource } from '../../app.utils';

const searchSpeakerPageState = () => {
    return {
        baseURL: process.env.VUE_APP_SPEAKER_BASE_URL,
        topicsList: [],
    };
};

const searchSpeakerPageMutations = {
    [storeMutation.setTopicsList]: (state, data) => {
        if (data.length > 0) {
            data.forEach((e) => {
                e.selectedTopics = [];
            });
        }
        state.topicsList = data;
    },

    [storeMutation.setSelectedTopics]: (state, filterTopics) => {
        if (filterTopics && filterTopics.length) {
            if (state.topicsList) {
                if (state.topicsList.length > 0) {
                    state.topicsList.forEach((e) => {
                        e.selectedTopics = [];
                    });
                }
                state.topicsList.forEach(topic =>
                    topic.childTopics.forEach((childTopic) => {
                        if (filterTopics.some(selectedTopic => selectedTopic === childTopic.topicName)) {
                            topic.selectedTopics.push(childTopic);
                        }
                    }),);
            }
        }
    },
};

const searchSpeakerPageActions = {
    [storeAction.getYPOSpeakers]: async ({ state, commit }, searchDetails) => {
        const searchBody = {};
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getSearchSpeakers,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        searchBody.search = searchDetails.searchText;
        searchBody.skip = searchDetails.nextSSPageSkip * speakerSearchConstants.RESULTS_PER_PAGE;
        searchBody.maxResultCount = speakerSearchConstants.RESULTS_PER_PAGE;
        searchBody.searchFilters = searchDetails.searchFilters;
        searchBody.orderBy = searchDetails.orderBy;

        return axios({
            url: `${state.baseURL}speaker/api/speakerdirectory`,
            headers: getSpeakerBasicHeaders(),
            data: searchBody,
            method: 'POST',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            })
            .finally(() => {
                commit(storeMutation.removeCancelableRequest, storeAction.getSearchSpeakers, { root: true });
            });
    },
    [storeAction.getTopicsList]: async ({ state, commit }, filterTopics) => {
        if (!state.topicsList || state.topicsList.length === 0) {
            return axios({
                url: `${state.baseURL}speaker/api/speaker/get/Topics`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setTopicsList, response.data);
                    commit(storeMutation.setSelectedTopics, filterTopics);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        } else if (state.topicsList.length > 0) {
            state.topicsList.forEach((e) => {
                e.selectedTopics = [];
            });
        }
    },
    [storeAction.getSpeakerSearchSuggestions]: wrapAction(
        storeAction.getSpeakerSearchSuggestions,
        async ({ state }, requestBody) => {
            return axios({
                url: `${state.baseURL}speaker/api/speakersearchautocomplete`,
                headers: getSpeakerBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
                    return response.data;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.initiateSpeakerTypeAheadSearch]: wrapAction(
        storeAction.initiateSpeakerTypeAheadSearch,
        ({ commit, state }, typeAheadObject) => {
            return axios({
                url: `${state.baseURL}speaker/api/typeAhead`,
                data: typeAheadObject,
                headers: getSpeakerBasicHeaders(),
                method: 'POST',
            })
                .then((response) => {
                    return response.data;
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    throw err;
                });
        },
    ),
};

const searchSpeakerPageGetters = {
    [storeGetters.topicsList]: state => state.topicsList,
};

export default {
    namespaced: true,
    state: {
        initialState: searchSpeakerPageState(),
        ...searchSpeakerPageState(),
    },
    mutations: { ...searchSpeakerPageMutations },
    actions: { ...searchSpeakerPageActions },
    getters: { ...searchSpeakerPageGetters },
};
